import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-moon-icon',
  template: `
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_18659_19475)">
        <path
          d="M9.27 4.98977C7.64 12.5298 13.02 17.3998 16.93 18.7898C15.54 19.8798 13.81 20.4998 12 20.4998C7.59 20.4998 4 16.9098 4 12.4998C4 9.04977 6.2 6.09977 9.27 4.98977ZM11.99 2.50977C6.4 2.50977 2 7.03977 2 12.4998C2 18.0198 6.48 22.4998 12 22.4998C15.71 22.4998 18.93 20.4798 20.66 17.4798C13.15 17.2298 8.57 9.04977 12.34 2.50977C12.22 2.50977 12.11 2.50977 11.99 2.50977Z"
          fill="#00719B"
        />
      </g>
      <defs>
        <clipPath id="clip0_18659_19475">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoonIconComponent {}
